import React from "react";
import { MobileStepper, MobileStepperProps } from "@mui/material";

// ------------- main mobile stepper export -------------
type WcMobileStepperProps = MobileStepperProps;

export const WcMobileStepper = ({ ...props }: WcMobileStepperProps) => <MobileStepper {...props} />;

export default WcMobileStepper;
// ----------------------------------------------------
